// extracted by mini-css-extract-plugin
export var card = "_mb-0";
export var content = "_mb-2";
export var details = "_mb-3";
export var icon = "_mb-1";
export var iconBlue = "_mb-5";
export var iconBrand = "_mb-4";
export var iconGrayBlue = "_mb-6";
export var iconGreen = "_mb-7";
export var iconIndigo = "_mb-8";
export var iconOrange = "_mb-9";
export var iconPurple = "_mb-a";
export var iconRed = "_mb-b";
export var iconWarning = "_mb-c";